import { render, staticRenderFns } from "./MenuReportVoucher.vue?vue&type=template&id=795a13fc&scoped=true&"
import script from "./MenuReportVoucher.vue?vue&type=script&lang=js&"
export * from "./MenuReportVoucher.vue?vue&type=script&lang=js&"
import style0 from "./MenuReportVoucher.vue?vue&type=style&index=0&id=795a13fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795a13fc",
  null
  
)

export default component.exports